var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEcosystemIcon = function SvgEcosystemIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-merch",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24.189
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.618 5.882a5.882 5.882 0 1 1 5.882 5.882 5.889 5.889 0 0 1-5.882-5.882ZM10.5 24.188A11.716 11.716 0 0 1 0 17.811a11.859 11.859 0 0 1 7.092-5.827 7.044 7.044 0 0 0 6.817 0 11.892 11.892 0 0 1 7.092 5.827 11.715 11.715 0 0 1-10.5 6.377Z"
  })));
};
export default SvgEcosystemIcon;